import React, { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("token");

    fetch(`${process.env.REACT_APP_API_URL}/me`, {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Invalid session");
        return res.json();
      })
      .then((userData) => {
        setUser(userData);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleSessionExpired = async (event) => {
      localStorage.removeItem("token");
      setUser(null);

      try {
        await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
          method: "POST",
          credentials: "include",
        });
      } catch (err) {
        console.error(err);
      }

      toast.error(event?.detail || "Your session expired. Please sign in again.");

      if (window.location.pathname !== "/login") {
        window.location.assign("/login?session_expired=true");
      }
    };

    window.addEventListener("recruitglance:session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("recruitglance:session-expired", handleSessionExpired);
    };
  }, []);

  const refreshUser = async () => {
    try {
      localStorage.removeItem("token");

      const res = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
        credentials: "include",
      });
      if (!res.ok) return;
      const data = await res.json();
      setUser(data);
    } catch (err) {
      console.error(err);
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem("token");

      await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error(err);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        logout,
        loading,
        isAuthenticated: !!user,
        refreshUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
